import $ from "jquery";
import AjaxRequest from "../modules/ajax-request";

class Account {
    constructor() {
        this._unmaskInput = $('[data-unmask-input]');
        this._cancelButton = $("[name='cancel-button']");
        this._unmaskBtn = $('[data-id="unmask"]');
        this._maskBtn = $('[data-id="mask"]');
        this._birthdayInput = $('[name="account_form[birthDate]"]');
        this._professionInput = $('[name="account_form[profession]"]');
        this._professionInputId = document.getElementById("account_form_profession");
        this._specialtyInput = $('[name="account_form[specialty]"]');
        this._specialtyOthersInput = $('[name="account_form[specialtyOthers]"]');
        this._pharmacyTypologyInput = $('[name="account_form[pharmacyTypology]"]');
        this._numberEmployeesInput = $('[name="account_form[numberEmployees]"]');
        this._courseLink = $('[data-courselink]');
        this.checkValue(null, $('#account_form_country'));

        this.init();
        this.bindEvents();
    }

    init() {
        if ($(this._birthdayInput).val() == "" || $(this._birthdayInput).length == 0) {
            this._birthdayInput.attr("placeholder", this._birthdayInput.data('placeholder'));
        }

        this._specialtyInput.parent().hide();
        this._specialtyOthersInput.parent().hide();
        this._pharmacyTypologyInput.parent().hide();
        this._numberEmployeesInput.parent().hide();

        if (this._courseLink.length > 0) {
            window.location.href = this._courseLink.data('courselink');
        }

        if (this._professionInputId.selectedIndex === 1) {
            this._specialtyInput.parent().show();
            this._pharmacyTypologyInput.parent().show();
            this._numberEmployeesInput.parent().show();
        } else if (this._professionInputId.selectedIndex === 7) {
            this._specialtyOthersInput.parent().show();
        }
    }

    bindEvents() {
        let _thisAccount = this;
        $('[name="account_form"]')
            .on("change", ' input', function (event) {
                _thisAccount.checkEmpty(event, $(this));
            })
            .on("change", 'select', function (event) {
                _thisAccount.checkEmpty(event, $(this));
                _thisAccount.checkValue(event, $(this));
            });

        $(this._cancelButton).on("click", function () {
            _thisAccount.cancelRenovation();
        });
        let _unmaskInput = this._unmaskInput;
        $(this._unmaskBtn).on("click", function () {
            $('[data-id="mask"]').show();
            $('[data-id="unmask"]').hide();
            _unmaskInput.attr("type", "password");
        });
        $(this._maskBtn).on("click", function () {
            $('[data-id="mask"]').hide();
            $('[data-id="unmask"]').show();
            _unmaskInput.attr("type", "text");
        });
        $(this._professionInput).on('change', function () {
            _thisAccount.showFields(this, event);
        });
        $(this.div).on("submit", this.form, function (event) {
            _thisAccount.submitForm(event);
        });
        $('body').on('change', '[name="account_form[birthDate]"]', function () {
            let tmpString = $(this).val().split("-");
            $(this).attr('placeholder', tmpString[2] + '/' + tmpString[1] + '/' + tmpString[0]);
        })
    }

    checkEmpty(event, element) {
        const optionalFields = ['account_form[nif]', 'account_form[placeOfWork]'];
        if (optionalFields.includes(element.attr('name'))) {
            return;
        }
        if (element.val() === "") {
            if (!element.hasClass('is-empty')) {
                element.addClass('is-empty');
            }
        } else {
            if (element.hasClass('is-empty')) {
                element.removeClass('is-empty');
            }
        }
    }

    checkValue(event, element) {
        if (element.attr('id') === "account_form_country") {
            if (element.val() !== "España") {
                $('#account_form_postalCode').parent().hide();
                $('#account_form_province').parent().hide();
            } else {
                $('#account_form_postalCode').parent().show();
                $('#account_form_province').parent().show();
            }
        }
    }

    cancelRenovation() {
        e.preventDefault();

        let _this = $(this);

        let url = $(this).attr("action");

        let ajaxRequest = new AjaxRequest({
            successCallback: function (response) {
                $('#message_cancel')
                    .removeClass("is-success is-failure")
                    .addClass(response.class)
                    .text(response.message);

                if (response.status === 200) {
                    _this.hide();
                }

            }
        });

        ajaxRequest.makeCall(url, _this.serialize());
    }

    showFields(professionSelect, event) {
        event.preventDefault();

        if (professionSelect.selectedIndex === 1) {
            this._specialtyInput.parent().show();
            this._specialtyOthersInput.parent().hide();
            document.getElementById("account_form_specialtyOthers").options.selectedIndex = 0;
        } else if (professionSelect.selectedIndex === 7) {
            this._specialtyOthersInput.parent().show();
            this._specialtyInput.parent().hide();
            document.getElementById("account_form_specialty").options.selectedIndex = 0;
        } else {
            this._specialtyInput.parent().hide();
            this._specialtyOthersInput.parent().hide();
            document.getElementById("account_form_specialty").options.selectedIndex = 0;
            document.getElementById("account_form_specialtyOthers").options.selectedIndex = 0;
        }
    }
}

export default Account;